(function () {
  if (window.__gpFrameGridBound) return;
  window.__gpFrameGridBound = true;
  // Editor section replacement must release window listeners and observers.
  var resizeControllers = new WeakMap();
  function onResize(node, callback) {
    var section = node.closest(".shopify-section") || document.body;
    var controller = resizeControllers.get(section);
    if (!controller) {
      controller = new AbortController();
      resizeControllers.set(section, controller);
    }
    window.addEventListener("resize", callback, { signal: controller.signal });
  }
  document.addEventListener("shopify:section:unload", function (event) {
    var controller = resizeControllers.get(event.target);
    if (controller) {
      controller.abort();
      resizeControllers.delete(event.target);
    }
    event.target.querySelectorAll(".mbf-card__reviews").forEach(function (row) {
      if (row.__gpKlaviyoObserver) row.__gpKlaviyoObserver.disconnect();
    });
  });

  function initCarousel(gallery) {
    if (!gallery || gallery.dataset.mbfCarouselInit === "1") return;
    gallery.dataset.mbfCarouselInit = "1";

    var imageWrap = gallery.closest(".mbf-card__image-wrap");
    if (!imageWrap) return;

    var dots = Array.prototype.slice.call(imageWrap.querySelectorAll("[data-mbf-dot]"));
    var prevButton = imageWrap.querySelector("[data-mbf-prev]");
    var nextButton = imageWrap.querySelector("[data-mbf-next]");
    var slidesCount = dots.length || gallery.children.length || 0;
    if (!slidesCount) return;

    function loadSlide(index) {
      var slide = gallery.children[(index + slidesCount) % slidesCount];
      var template = slide && slide.querySelector("template[data-mbf-slide-image]");
      if (!template) return;
      var content = template.content.cloneNode(true);
      content.querySelectorAll("img").forEach(function (image) {
        image.loading = "eager";
        image.sizes = Math.ceil(gallery.clientWidth) + "px";
      });
      template.replaceWith(content);
    }

    function prepareAdjacentSlides() {
      var index = currentIndex();
      loadSlide(index);
      loadSlide(index + 1);
      loadSlide(index - 1);
    }

    imageWrap.addEventListener("pointerenter", prepareAdjacentSlides, { once: true });
    imageWrap.addEventListener("pointerdown", prepareAdjacentSlides, { passive: true });
    imageWrap.addEventListener("focusin", prepareAdjacentSlides);

    function currentIndex() {
      var width = gallery.clientWidth || 1;
      var index = Math.round(gallery.scrollLeft / width);
      return Math.max(0, Math.min(slidesCount - 1, index));
    }

    function updateUI() {
      var index = currentIndex();
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle("is-active", dotIndex === index);
      });
    }

    function goTo(index) {
      var clamped = (index + slidesCount) % slidesCount;
      loadSlide(clamped);
      var width = gallery.clientWidth || 1;
      gallery.scrollTo({ left: width * clamped, behavior: "smooth" });
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function (event) {
        event.preventDefault();
        goTo(Number(dot.getAttribute("data-slide-index") || 0));
      });
    });

    if (prevButton) {
      prevButton.addEventListener("click", function (event) {
        event.preventDefault();
        goTo(currentIndex() - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function (event) {
        event.preventDefault();
        goTo(currentIndex() + 1);
      });
    }

    var ticking = false;
    gallery.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          prepareAdjacentSlides();
          updateUI();
          ticking = false;
        });
      },
      { passive: true },
    );

    onResize(gallery, updateUI);
    updateUI();
  }

  function initMobileFrameLimit(root) {
    (root || document).querySelectorAll('.mbf[data-mobile-limit="true"]').forEach(function (mbf) {
      if (mbf.dataset.mbfMobileLimitInit === "1") return;
      mbf.dataset.mbfMobileLimitInit = "1";

      var toggle = mbf.querySelector("[data-mbf-mobile-toggle]");
      var labelNode = toggle ? toggle.querySelector("[data-mbf-mobile-toggle-label]") : null;
      var moreLabel = mbf.getAttribute("data-mobile-show-more-label") || "Show more frames";
      var lessLabel = mbf.getAttribute("data-mobile-show-less-label") || "Show fewer frames";

      function isMobile() {
        return window.matchMedia("(max-width: 767px)").matches;
      }

      function applyState(collapsed) {
        mbf.classList.toggle("mbf--mobile-collapsed", collapsed);
        if (toggle) {
          toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
          if (labelNode) labelNode.textContent = collapsed ? moreLabel : lessLabel;
        }
      }

      var wasMobile = isMobile();
      applyState(wasMobile);

      function lastVisibleCard() {
        var cards = mbf.querySelectorAll(".mbf-card");
        for (var i = cards.length - 1; i >= 0; i--) {
          if (cards[i].offsetParent !== null) return cards[i];
        }
        return null;
      }

      if (toggle) {
        toggle.addEventListener("click", function (event) {
          event.preventDefault();
          if (!isMobile()) return;
          var collapsed = mbf.classList.contains("mbf--mobile-collapsed");
          // Keep the reader in place: on "more" the last frame they could see stays
          // put and the new ones open below it; on "fewer" the button stays under
          // their finger instead of the page landing past the section.
          var anchor = collapsed ? lastVisibleCard() : toggle;
          var before = anchor ? anchor.getBoundingClientRect().top : 0;
          applyState(!collapsed);
          if (anchor) {
            var shift = anchor.getBoundingClientRect().top - before;
            if (Math.abs(shift) > 1) window.scrollTo(0, window.scrollY + shift);
          }
        });
      }

      onResize(mbf, function () {
        var nowMobile = isMobile();
        if (nowMobile === wasMobile) return;
        wasMobile = nowMobile;

        if (nowMobile) {
          applyState(true);
        } else {
          mbf.classList.remove("mbf--mobile-collapsed");
          if (toggle) {
            toggle.setAttribute("aria-expanded", "true");
            if (labelNode) labelNode.textContent = lessLabel;
          }
        }
      });
    });
  }

  function renderKlaviyoWidgets(root) {
    var scope = root || document;
    if (!scope.querySelector(".klaviyo-star-rating-widget")) return;
    if (window.klReviewsObject && typeof window.klReviewsObject.renderWidgets === "function") {
      window.klReviewsObject.renderWidgets();
    }
  }

  function syncReviewFallbacks(root) {
    var scope = root || document;
    (scope.matches && scope.matches(".mbf-card__reviews")
      ? [scope]
      : scope.querySelectorAll(".mbf-card__reviews")
    ).forEach(function (reviewsEl) {
      var widget = reviewsEl.querySelector(".klaviyo-star-rating-widget");
      var hasRenderedWidget = !!(
        widget &&
        (widget.querySelector('.kl_reviews__star_rating_widget, [class*="kl_reviews"], svg, img') ||
          widget.children.length > 0 ||
          widget.textContent.trim().length > 0)
      );
      reviewsEl.setAttribute("data-klaviyo-ready", hasRenderedWidget ? "true" : "false");
    });
  }

  function observeReviewWidgets(root) {
    var scope = root || document;
    (scope.matches && scope.matches(".mbf-card__reviews")
      ? [scope]
      : scope.querySelectorAll(".mbf-card__reviews")
    ).forEach(function (reviewsEl) {
      if (reviewsEl.__gpKlaviyoObserverBound) return;
      var observer = new MutationObserver(function () {
        syncReviewFallbacks(reviewsEl);
      });
      observer.observe(reviewsEl, { childList: true, subtree: true });
      reviewsEl.__gpKlaviyoObserverBound = true;
      reviewsEl.__gpKlaviyoObserver = observer;
    });
    syncReviewFallbacks(scope);
  }

  function scheduleKlaviyoRender(root) {
    [0, 300, 1000, 2500, 5000].forEach(function (delay) {
      window.setTimeout(function () {
        renderKlaviyoWidgets(root);
        syncReviewFallbacks(root);
      }, delay);
    });
  }

  function queueKlarnaPlacements(root) {
    var scope = root || document;
    var mounted = (window.__gpMbfKlarnaMounted = window.__gpMbfKlarnaMounted || {});
    var rows = scope.querySelectorAll(".mbf-card__klarna-mini");
    if (!rows.length) return;

    window.appBlockPlacements = window.appBlockPlacements || [];

    rows.forEach(function (row) {
      var el = row.querySelector("klarna-placement[id]");
      if (!el) return;
      var configNode = row.closest(".mbf").querySelector("[data-gp-frame-grid-config]");
      var config = configNode ? JSON.parse(configNode.textContent) : {};
      var selector = el.id;
      var amount =
        row.getAttribute("data-klarna-amount") || el.getAttribute("data-purchase-amount") || "";
      if (amount) {
        el.setAttribute("data-purchase-amount", amount);
      }
      var placement = {
        productVariants: [],
        templateName: config.templateName,
        shopLocale: config.shopLocale,
        dataKey: "credit-promotion-badge",
        storefrontCurrency: config.storefrontCurrency,
        storefrontCountry: config.storefrontCountry,
        storefrontLanguage: config.storefrontLanguage,
        shopDomain: config.shopDomain,
        variantPrice: String(amount),
        cartPrice: String(amount),
        selector: selector,
        topPadding: "0",
        bottomPadding: "0",
      };

      if (
        !window.appBlockPlacements.some(function (item) {
          return item && item.selector === selector;
        })
      ) {
        window.appBlockPlacements.push(placement);
      }

      if (
        !mounted[selector] &&
        window.klarnaAppBlocksManager &&
        typeof window.klarnaAppBlocksManager.push === "function"
      ) {
        window.klarnaAppBlocksManager.push(placement);
        mounted[selector] = true;
      }
    });
  }

  function refreshKlarna(root) {
    queueKlarnaPlacements(root);

    try {
      if (window.KlarnaOnsiteService && typeof window.KlarnaOnsiteService.push === "function") {
        window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
        return;
      }
      if (
        window.Klarna &&
        window.Klarna.OnsiteMessaging &&
        typeof window.Klarna.OnsiteMessaging.refresh === "function"
      ) {
        window.Klarna.OnsiteMessaging.refresh();
      }
    } catch (error) {}
  }

  function scheduleKlarnaRender(root) {
    [0, 300, 1000, 2500, 5000, 8000].forEach(function (delay) {
      window.setTimeout(function () {
        refreshKlarna(root);
      }, delay);
    });
  }

  function initRoot(root) {
    var scope = root || document;
    scope.querySelectorAll(".mbf-card__image-gallery").forEach(initCarousel);
    initMobileFrameLimit(scope);
    observeReviewWidgets(scope);
    scheduleKlaviyoRender(scope);
    scheduleKlarnaRender(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initRoot(document);
      },
      { once: true },
    );
  } else {
    initRoot(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    initRoot(event.target);
  });
})();
